import React, { useEffect, useRef, useState } from "react";
import { Button, FormControlLabel, Grid, Paper, Radio, RadioGroup, TableBody } from "@mui/material";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import './Chart.css';
import axios from "axios";
import { Bar, getElementAtEvent, Pie, PolarArea } from "react-chartjs-2";
import useAuth from "../../hooks/useAuth";
import { DASHBOARD_BASE_URL, GraphChoice, HotelRoomCateogory, isEmpty, printDebugLog, SUCCESS } from "../../constants/Constants";
import SnpComponent from "../../global/SnpComponent";

import { Chart as ChartJS } from "chart.js/auto";

export default function OwnerDashboard() {

    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: true,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        iconReq: false,
        iconContent: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        requestType: 0,
        handleSnpSubmit: null,
        handleSnpCancel: null,
    };

    const INITIAL_CHART_DATA = {
        data: { labels: [], datasets: [] }, show: false, type: HotelRoomCateogory.HOTEL_BOTH, graphLabel: "", choice: -1
    }

    const salesExpenseRef = useRef();
    const countRef = useRef();

    const { activeShopHash, authUser } = useAuth();
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);

    const [dayBookDesigns, setDayBookColVals] = useState([]);
    const [userPieData, setUserPieData] = useState([]);
    const [userPieDataToday, setUserPieDataToday] = useState([]);
    const [showPie, setShowPie] = useState(false);

    const [snpLoader, setSnpLoader] = useState(false);

    const [roomData, setRoomData] = useState(INITIAL_CHART_DATA);
    const [banquetData, setBanquetData] = useState(INITIAL_CHART_DATA);
    const [salesExpenseGraphData, setSalesExpenseGraphData] = useState(INITIAL_CHART_DATA);
    const [countGraphData, setCountGraphData] = useState(INITIAL_CHART_DATA);

    useEffect(() => {
        console.log("Refs:", { sales: salesExpenseRef.current, count: countRef.current });
        networkCall();
    }, []);


    const getAccountingChart = async () => {
        try {
            const catgUrl = `${DASHBOARD_BASE_URL}get-accounting-chart?apiToken=${authUser.apiToken}&shopHash=${activeShopHash.id}&ownerRequest=${false}`;
            const response = await axios.get(catgUrl);
            if (response.data.status === SUCCESS) {
                setDayBookColVals(response.data.payLoad.dayBook);
                //backgroundColor: ["#4d908e", "#122121", "#2d5352" , "#f9844a", "#df4f07", "#990000","#4d0000"],
                setUserPieData({
                    ...userPieData,
                    labels: response.data.payLoad.dayBookDesigns.map(data => data.tye),
                    datasets: [{
                        label: "Accounting",
                        data: response.data.payLoad.dayBookDesigns.map(data => data.total),
                        backgroundColor: ["#4d0000", "#4d908e", "#122121", "#f9844a"],
                        hoverOffset: 4
                    }]
                });
                setUserPieDataToday({
                    ...userPieDataToday,
                    labels: response.data.payLoad.dayBookDesignsToday.map(data => data.tye),
                    datasets: [{
                        label: "Accounting",
                        data: response.data.payLoad.dayBookDesignsToday.map(data => data.total),
                        backgroundColor: ["#990000", "#2d5352", "#df4f07"],
                        hoverOffset: 4
                    }]
                });
                setShowPie(true);
            }
        } catch (err) {
            console.error("getAccountingData", err);
        }
    };

    const dashboardBookingCount = async (isBanquet) => {
        try {
            const mUrl = `${DASHBOARD_BASE_URL}dashboard-booking-count?shopHash=${activeShopHash.id}&banquet=${isBanquet}&cancel=${true}`;
            const response = await axios.get(mUrl);
            printDebugLog("dashboardBookingCount=>", response);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.payLoad;
                if (isBanquet) {
                    setBanquetData(prev => ({
                        ...prev, show: true,
                        data: {
                            labels: ["Today's Booking Count", "Today's CheckIn", "Today's Checkout",
                                "Total Live Booking", "Today's Cancelled Bill", "Total Cancelled Bill"],
                            datasets: [{
                                label: "Banquet Data",
                                data: [payLoad.todaysBookingCount, payLoad.todaysCheckInCount,
                                payLoad.todaysCheckOutCount, payLoad.totalBookingCount, payLoad.todaysCancelCount, payLoad.totalCancelCount],
                                backgroundColor: [
                                    'rgba(255, 99, 132, 0.5)',
                                    'rgba(54, 162, 235, 0.5)',
                                    'rgba(255, 206, 86, 0.5)',
                                    'rgba(75, 192, 192, 0.5)',
                                    'rgba(153, 102, 255, 0.5)',
                                    'rgba(255, 159, 64, 0.5)',
                                ],
                                borderWidth: 1,
                            }]
                        }
                    }))
                } else {
                    setRoomData(prev => ({
                        ...prev, show: true,
                        data: {
                            labels: ["Today's Booking Count", "Today's CheckIn", "Today's Checkout",
                                "Total Live Booking", "Today's Cancelled Bill", "Total Cancelled Bill"],
                            datasets: [{
                                label: "Room Data",
                                data: [payLoad.todaysBookingCount, payLoad.todaysCheckInCount,
                                payLoad.todaysCheckOutCount, payLoad.totalBookingCount, payLoad.todaysCancelCount, payLoad.totalCancelCount],
                                backgroundColor: [
                                    'rgba(255, 99, 132, 0.5)',
                                    'rgba(54, 162, 235, 0.5)',
                                    'rgba(255, 206, 86, 0.5)',
                                    'rgba(75, 192, 192, 0.5)',
                                    'rgba(153, 102, 255, 0.5)',
                                    'rgba(255, 159, 64, 0.5)',
                                ],
                            }]
                        }
                    }))
                }
            }
        } catch (error) {
            console.error("dashboardBookingCount ", isBanquet, error);
        }
    }

    const buildGraphCommonUiRequest = (mType, mGraphLabel, mChoice) => {
        return `?shopHash=${activeShopHash.id}&apiToken=${authUser.apiToken}&type=${mType}&graphLabel=${mGraphLabel}&choice=${mChoice}`
    }

    const drawSaleExpenseGraph = async ({ mType = HotelRoomCateogory.HOTEL_BOTH, mGraphLabel = "", mChoice }) => {
        try {
            const mUrl = `${DASHBOARD_BASE_URL}draw-sale-expense-graph${buildGraphCommonUiRequest(mType, mGraphLabel, mChoice)}`;
            const response = await axios.get(mUrl);
            printDebugLog("drawSaleExpenseGraph=>", response);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.payLoad;
                setSalesExpenseGraphData(prev => ({
                    ...prev, show: true,
                    type: mType,
                    graphLabel: mGraphLabel,
                    choice: payLoad.choice,
                    data: {
                        labels: payLoad.data.map(data => data.type),
                        datasets: [
                            {
                                label: "Bookings/Sale",
                                type: "bar",
                                data: payLoad.data.map(data => data.salevalue),
                                backgroundColor: "#2d5352",
                                hoverOffset: 4,
                                yAxisID: "y1",
                            },
                            {
                                label: "Expense",
                                type: "bar",
                                data: payLoad.data.map(data => data.expenseValue),
                                backgroundColor: "rgba(250, 6, 6, 1)",
                                hoverOffset: 4,
                                yAxisID: "y1",
                            },
                            {
                                label: "Paid amount",
                                type: "line",
                                data: payLoad.data.map(data => data.paidAmount),
                                fill: false,
                                borderColor: "rgba(2, 26, 16, 1)",
                                borderWidth: 2,
                                tension: 0.3,
                                pointBackgroundColor: "rgba(44, 136, 82, 1)",
                                yAxisID: "y2",
                            },
                            {
                                label: "Dues",
                                type: "line",
                                data: payLoad.data.map(data => data.dues),
                                fill: false,
                                borderColor: "rgba(236, 195, 11, 1)",
                                borderWidth: 2,
                                tension: 0.3,
                                pointBackgroundColor: "rgba(179, 136, 20, 1)",
                                yAxisID: "y2",
                            },
                        ]
                    }
                }))
            }
        } catch (error) {
            console.error("drawSaleExpenseGraph ", error);
        }
    }

    const drawCountGraph = async ({ mType = HotelRoomCateogory.HOTEL_BOTH, mGraphLabel = "", mChoice }) => {
        try {
            const mUrl = `${DASHBOARD_BASE_URL}draw-count-graph${buildGraphCommonUiRequest(mType, mGraphLabel, mChoice)}`;
            const response = await axios.get(mUrl);
            printDebugLog("drawCountGraph=>", response);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.payLoad;
                setCountGraphData(prev => ({
                    ...prev,
                    show: true,
                    type: mType,
                    graphLabel: mGraphLabel,
                    choice: payLoad.choice,
                    data: {
                        labels: payLoad.data.map(data => data.type),
                        datasets: [
                            {
                                label: "Bookings/Sale Count",
                                type: "bar",
                                data: payLoad.data.map(data => data.totalBookingCount),
                                backgroundColor: "#2d5352",
                                hoverOffset: 4,
                                yAxisID: "y1",
                            },
                            {
                                label: "Cancelled Bill Count",
                                type: "line",
                                data: payLoad.data.map(data => data.totalCancelledCount),
                                fill: false,
                                borderColor: "rgba(236, 75, 11, 1)",
                                borderWidth: 2,
                                tension: 0.3,
                                pointBackgroundColor: "rgba(238, 103, 41, 1)",
                                yAxisID: "y2",
                            },
                        ]
                    }
                }))
            }
        } catch (error) {
            console.error("drawCountGraph ", error);
        }
    }

    const handleGraphClick = (event, graphData, graphRef, drawGraph) => {
        printDebugLog("handleGraphClick", event, graphData);
        const graphCtx = graphRef?.current;
        if (!graphCtx) {
            printDebugLog("undefined context");
            return;
        }
        if (graphData.choice === GraphChoice.DAYS_OF_WEEK) {
            setSnpComponent(prev => ({
                ...prev, snackBarMsg: "Request is not allowed, so resetting",
                snackBarOpen: true,
            }))
            drawGraph({
                mType: HotelRoomCateogory.HOTEL_BOTH,
                mGraphLabel: "", mChoice: -1
            })
        } else {
            const ev = getElementAtEvent(graphCtx, event);
            if (ev && ev.length > 0) {
                printDebugLog("handleGraphClick click",
                    ev, ev[0].index);
                const single = graphData.data.labels[ev[0].index];
                printDebugLog("handleGraphClick get", single);
                drawGraph({
                    mType: graphData.type,
                    mGraphLabel: single,
                    mChoice: (graphData.choice - 1),
                });
            }
        }
    }


    const networkCall = async () => {
        setSnpLoader(true);
        await getAccountingChart();
        await dashboardBookingCount(false); //Room
        await dashboardBookingCount(true); //Banquet
        await drawCountGraph({ mType: HotelRoomCateogory.HOTEL_BOTH, mGraphLabel: "", mChoice: -1 });
        await drawSaleExpenseGraph({ mType: HotelRoomCateogory.HOTEL_BOTH, mGraphLabel: "", mChoice: -1 });
        setSnpLoader(false);
    }


    const options = {
        responsive: true,
        maintainAspectRatio: false, // This allows you to control the chart dimensions
    };



    const ShowRoomBanquetFilter = (resetVisible, filterSelection, setFilterSelection, handleReset) => {
        return (
            <>
                <Grid item xs={12} md={6} sm={6}>
                    <RadioGroup
                        row
                        aria-label="type"
                        name="type"
                        value={filterSelection}
                        onChange={(e) => setFilterSelection(Number(e.target.value))}
                    >
                        <FormControlLabel
                            value={HotelRoomCateogory.HOTEL_ROOM}
                            control={<Radio />}
                            label="Only Room"
                        />
                        <FormControlLabel
                            value={HotelRoomCateogory.HOTEL_BANKQUET}
                            control={<Radio />}
                            label="Only Banquet"
                        />
                        <FormControlLabel
                            value={HotelRoomCateogory.HOTEL_BOTH}
                            control={<Radio />}
                            label="Room/Banquet"
                        />
                    </RadioGroup>
                </Grid>
                {
                    resetVisible &&
                    <Grid item xs={12} sm={6} md={6}>
                        <Button variant="contained" color="primary" onPointerDown={() => handleReset()}>
                            Reset
                        </Button>
                    </Grid>
                }
            </>
        )
    }

    const AccountingPieCharts = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ width: '250px', height: '250px' }}>
                    <Pie data={userPieDataToday} options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            title: {
                                display: true,
                                text: "Today's Booking Value",
                            },
                            legend: {
                                position: "top",
                            },
                        },
                    }} />
                </div>
                <div style={{ width: '250px', height: '250px' }}>
                    <Pie data={userPieData} options={options} />
                </div>
            </div>
        );
    };

    const DashboardBookingPolarCharts = () => {
        return (
            <Paper
                elevation={0}
                autoHeight
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "background.paper",
                    boxShadow: 9,
                    borderRadius: 4,
                    margin: 1,
                    padding: 1,
                }}
            >
                <Grid container spacing={0}>
                    {
                        roomData.show &&
                        <Grid item xs={12} md={6}>
                            <div style={{ width: "350px", height: "350px" }}>
                                <PolarArea data={roomData.data} options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: "Room Booking Value",
                                        },
                                        legend: {
                                            position: "top",
                                        },
                                    },
                                }} />
                            </div>
                        </Grid>
                    }
                    {
                        banquetData.show &&
                        <Grid item xs={12} md={6}>
                            <div style={{ width: "350px", height: "350px" }}>
                                <PolarArea data={banquetData.data} options={{
                                    responsive: true,
                                    maintainAspectRatio: false,
                                    plugins: {
                                        title: {
                                            display: true,
                                            text: "Banquet Booking Value",
                                        },
                                        legend: {
                                            position: "top",
                                        },
                                    },
                                }} />
                            </div>
                        </Grid>
                    }
                </Grid>
            </Paper>
        );
    };

    const SaleExpenseGraphUi = () => {
        return (
            <Paper
                elevation={0}
                autoHeight
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "background.paper",
                    boxShadow: 9,
                    borderRadius: 4,
                    margin: 1,
                    padding: 1,
                }}
            >
                <Grid container spacing={0} sx={{ justifyContent: "center" }}>
                    {ShowRoomBanquetFilter(
                        (salesExpenseGraphData.type !== HotelRoomCateogory.HOTEL_BOTH || !isEmpty(salesExpenseGraphData.graphLabel)),
                        salesExpenseGraphData.type,
                        (type) => drawSaleExpenseGraph({
                            mType: type,
                            mGraphLabel: salesExpenseGraphData.graphLabel, mChoice: salesExpenseGraphData.choice
                        }),
                        () => drawSaleExpenseGraph({
                            mType: HotelRoomCateogory.HOTEL_BOTH,
                            mGraphLabel: "", mChoice: -1
                        })
                    )}
                    <Grid item xs={12}>
                        <Bar
                            ref={salesExpenseRef}
                            data={salesExpenseGraphData.data}
                            onClick={(event) =>
                                handleGraphClick(event, salesExpenseGraphData, salesExpenseRef, drawSaleExpenseGraph)}
                            options={{
                                responsive: true,
                                interaction: {
                                    mode: "index",
                                    intersect: false,
                                },
                                plugins: {
                                    title: {
                                        display: true,
                                        text: "Sales/Expense",
                                    },
                                    legend: {
                                        position: "top",
                                    },
                                },
                                scales: {
                                    y1: {
                                        type: "linear",
                                        position: "left",
                                        beginAtZero: true,
                                        title: {
                                            display: true,
                                            text: "Amount",
                                        },
                                    },
                                    y2: {
                                        type: "linear",
                                        position: "right",
                                        beginAtZero: true,
                                        grid: {
                                            drawOnChartArea: false, // prevents duplicate grid lines
                                        },
                                        title: {
                                            display: true,
                                            text: "Amount",
                                        },
                                    },
                                    x: {
                                        title: {
                                            display: true,
                                            text: "Month",
                                        },
                                    },
                                },
                            }} />
                    </Grid>
                </Grid>
            </Paper>
        );
    }

    const CountGraphUi = () => {
        return (
            <Paper
                elevation={0}
                autoHeight
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "background.paper",
                    boxShadow: 9,
                    borderRadius: 4,
                    margin: 1,
                    padding: 1,
                }}
            >
                <Grid container spacing={0} sx={{ justifyContent: "center" }}>
                    {ShowRoomBanquetFilter(
                        (countGraphData.type !== HotelRoomCateogory.HOTEL_BOTH || !isEmpty(countGraphData.graphLabel)),
                        countGraphData.type,
                        (type) => drawCountGraph({
                            mType: type,
                            mGraphLabel: countGraphData.graphLabel, mChoice: countGraphData.choice
                        }),
                        () => drawCountGraph({
                            mType: HotelRoomCateogory.HOTEL_BOTH,
                            mGraphLabel: "", mChoice: -1
                        })
                    )}
                    <Grid item xs={12}>
                        <Bar
                            ref={countRef}
                            data={countGraphData.data}
                            onClick={(event) =>
                                handleGraphClick(event, countGraphData, countRef, drawCountGraph)}
                            options={{
                                responsive: true,
                                interaction: {
                                    mode: "index",
                                    intersect: false,
                                },
                                plugins: {
                                    title: {
                                        display: true,
                                        text: "Booking/Cancelled Count",
                                    },
                                    legend: {
                                        position: "top",
                                    },
                                },
                                scales: {
                                    y1: {
                                        type: "linear",
                                        position: "left",
                                        beginAtZero: true,
                                        title: {
                                            display: true,
                                            text: "No. of Booking/Sale",
                                        },
                                    },
                                    y2: {
                                        type: "linear",
                                        position: "right",
                                        beginAtZero: true,
                                        grid: {
                                            drawOnChartArea: false, // prevents duplicate grid lines
                                        },
                                        title: {
                                            display: true,
                                            text: "No of Cancelled Bill",
                                        },
                                    },
                                    x: {
                                        title: {
                                            display: true,
                                            text: "Month",
                                        },
                                    },
                                },
                            }} />
                    </Grid>
                </Grid>
            </Paper>
        );
    }


    const AccountingDetails = () => {
        return (
            <Paper
                elevation={0}
                autoHeight
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "background.paper",
                    boxShadow: 9,
                    borderRadius: 4,
                    margin: 1,
                    padding: 1,
                }}
            >
                <Grid container spacing={0} display="flex"
                    alignItems="center">
                    {
                        showPie &&
                        <Grid item md={5} sm={12} xs={12} lg={5}>
                            {AccountingPieCharts()}
                        </Grid>
                    }
                    <Grid item md={7} sm={12} xs={12} lg={7}>
                        <TableContainer component={Paper}>
                            <Table aria-label="simple table" className="rate_card">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center">Cash(₹)</TableCell>
                                        <TableCell align="center">Online(₹)</TableCell>
                                        <TableCell align="center">T.Amt(₹)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Object.values(dayBookDesigns).map((val, index) => {
                                        return (
                                            <TableRow
                                                key={index + "_" + val.tye}
                                                className="rate_card--row"
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell align="center">{val.tye}</TableCell>
                                                <TableCell align="center" >{val.cash}</TableCell>
                                                <TableCell align="center" >{val.online}</TableCell>
                                                <TableCell align="center" >{val.total}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </Paper>
        )
    };

    const renderSnpContent = () => {
        return (
            <Grid container spacing={0}>
                <Grid item xs={12}>
                    {AccountingDetails()}
                </Grid>
                <Grid item xs={12}>
                    {DashboardBookingPolarCharts()}
                </Grid>
                <Grid item xs={12} style={{ display: countGraphData.show ? 'block' : 'none' }}>
                    {CountGraphUi()}
                </Grid>
                <Grid item xs={12} style={{ display: salesExpenseGraphData.show ? 'block' : 'none' }}>
                    {SaleExpenseGraphUi()}
                </Grid>

            </Grid>
        );
    };

    return (
        <>
            <SnpComponent showDialog={snpComponent.showDialog}
                title={snpComponent.title}
                isLoader={snpLoader}
                subTitle={snpComponent.subTitle}
                negativeAction={snpComponent.negativeAction}
                positiveReq={snpComponent.positiveReq}
                positiveAction={snpComponent.positiveAction}
                negativeReq={snpComponent.negativeReq}
                iconReq={snpComponent.iconReq}
                iconContent={snpComponent.iconContent}
                content={renderSnpContent()}
                onSnackClose={() => setSnpComponent(prev => ({
                    ...prev,
                    snackBarOpen: false,
                    snackBarMsg: "",
                }))}
                handleSubmit={snpComponent.handleSnpSubmit}
                onCancel={snpComponent.handleSnpCancel}
                cancelExtra={snpComponent.cancelExtra}
                snackBarOpen={snpComponent.snackBarOpen}
                snackBarMsg={snpComponent.snackBarMsg}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
            />
        </>
    );


}